/**
 * 役所資料取得代行機能で使用する定数。
 */

/** 1 件あたりのサービス利用手数料（円） */
export const SERVICE_FEE_PER_ITEM = 1000;

/** 拠点追加ごとにかかる追加費用（円）。1 都 3 県以外かつ拠点が 2 件以上の場合に適用 */
export const ADDITIONAL_LOCATION_FEE = 1200;

/** レターパック郵送費用（円） */
export const POSTAL_FEE = 430;

/**
 * 1 都 3 県以外の最低発注料金（円）。サービス利用手数料のみに適用する。
 * NATIONWIDE_MINIMUM_INCLUDED_ITEMS 件までこの料金に含み、超過分は 1 件につき
 * SERVICE_FEE_PER_ITEM を加算する（例: 3 件 = ¥3,500 / 4 件 = ¥4,500 / 5 件 = ¥5,500）。
 * 拠点追加費用・実費・郵送費用とは独立して扱う。
 */
export const NATIONWIDE_MINIMUM_FEE = 3500;

/** NATIONWIDE_MINIMUM_FEE に含まれる件数 */
export const NATIONWIDE_MINIMUM_INCLUDED_ITEMS = 3;

/** その他書類の最大入力件数 */
export const MAX_CUSTOM_INPUTS = 10;

/** 関連資料アップロードで許可する拡張子 */
export const TOUHON_ALLOWED_EXTENSIONS = [".pdf", ".zip"];

/** 1 都 3 県（拠点追加費用が不要なエリア） */
export const TOKYO_METRO_PREFECTURES = [
  "東京都",
  "神奈川県",
  "埼玉県",
  "千葉県",
];
